<template>
  <client-only>
    <div class="headline-publish-date">
      {{ date | formatDateWithTime }}
    </div>
  </client-only>
</template>
<script lang="ts">
import Vue from 'vue';
import { getRootConfig } from '@core/utils/helpers';
import { formatDateWithTime } from '@root/common/filters/dateFormater';

interface Props {
  date: string;
  dateFormat: string;
}

interface Data {
  locale: string;
}

export default Vue.extend<Data, unknown, unknown, Props>({
  filters: {
    formatDateWithTime,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    /**
     * Supports dayjs formats
     */
    dateFormat: {
      type: String,
      default: 'DD.MM.YYYY, HH:mm',
      required: false,
    },
  },
  data() {
    return {
      locale: 'lt',
    };
  },
  mounted() {
    const settings = getRootConfig('settings');
    if (settings && settings.locale) {
      this.locale = settings.locale.split('_')[0];
    }
  },
});
</script>
<style lang="scss">
.headline-publish-date {
  font-family: get-font-family('system');
  font-size: 11px;
  font-weight: get-font-weight('semi-bold');
  color: get-color('grey-1');
  line-height: 1;
  margin-top: 10px;
}
</style>
